import { ModelLookupContext } from "@auer-steel/Contexts/ModelLookup/ModelLookupContext";
import { ModelLookupContextProvider } from "@auer-steel/Contexts/ModelLookup/ModelLookupContextProvider";
import ModelSearch from "@auer-steel/CustomComponents/ModelLookup/ModelSearch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoriesDataView } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";

import ModelSearchListDetail from "@auer-steel/CustomComponents/ModelLookup/ModelSearchListDetail";
import ModelSearchResultsList from "@auer-steel/CustomComponents/ModelLookup/ModelSearchResultsList";
import { getModelLookupByModelNumber } from "@auer-steel/Services/ModelLookupService";
import * as React from "react";
import { render } from "react-dom";

const mapStateToProps = (state: ApplicationState) => {
    const categoriesDataView = getCategoriesDataView(state);
    return {
        shouldLoadCategories: !categoriesDataView.value && !categoriesDataView.isLoading,
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps>;

function ModelLookupPage() {
    const modelLookupContext = React.useContext(ModelLookupContext);
    const { modelNumber, modelLookupResultsData, isLoading } = modelLookupContext;

    return (
        <ModelLookupContextProvider>
            <Page>
                <ModelSearch />
            </Page>
        </ModelLookupContextProvider>
    );
}

const pageModule: PageModule = {
    component: ModelLookupPage,
    definition: {
        displayName: "ModelLookupPage",
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

export const ModelLookupPageContext = "ModelLookupPage";
